/**
 * Document types supported for ID scan uploads
 *
 * This enum defines the valid document types that can be requested
 * through the document upload link API endpoints.
 *
 */
export const EDocumentUploadType = {
  GOVERNMENT_PHOTO_ID: "government_photo_id",
  PASSPORT: "passport",
  SOCIAL_SECURITY_CARD: "social_security_card",
  OTHER: "other",
} as const;

export type TDocumentUploadType =
  (typeof EDocumentUploadType)[keyof typeof EDocumentUploadType];
